import { OutlookAvailabilityTime, OutlookAvailabilityTimeData } from './OutlookAvailabilityTime'

/**
 * Date Time Table structure for Outlook compatibility
 *
 * Example:
 * {
 *   "dayLabel": "2022년 4월 25일 월요일",
 *   "timeSlots": [
 *     {
 *       "endDate": "2022-04-25T13:00:00+09:00",
 *       "endDateLabel":  "오후 1:00",
 *       "startDate": "2022-04-25T12:30:00+09:00",
 *       "startDateLabel": "오후 12:30",
 *       "timeZone": "GMT+9"
 *     },
 *     {
 *        "endDate": "2022-04-25T19:00:00+09:00",
 *        "endDateLabel": "오후 7:00",
 *        "startDate": "2022-04-25T18:30:00+09:00",
 *        "startDateLabel": "오후 6:30",
 *         "timeZone": "GMT+9"
 *     },
 *     ...
 *   ]
 * }
 */

export interface DateTimeTableData {
  dayLabel: string
  timeSlots: OutlookAvailabilityTimeData[]
}

export class DateTimeTable {
  dayLabel: string
  timeSlots: OutlookAvailabilityTime[]

  constructor(dayLabel: string, timeSlots: OutlookAvailabilityTime[]) {
    this.dayLabel = dayLabel
    this.timeSlots = timeSlots
  }

  /**
   * Convert to plain object for JSON serialization
   */
  toJSON(): DateTimeTableData {
    return {
      dayLabel: this.dayLabel,
      timeSlots: this.timeSlots.map((slot) => slot.toJSON()),
    }
  }

  /**
   * Create instance from plain object
   */
  static fromJSON(data: DateTimeTableData): DateTimeTable {
    const timeSlots = data.timeSlots.map((slotData) => OutlookAvailabilityTime.fromJSON(slotData))
    return new DateTimeTable(data.dayLabel, timeSlots)
  }

  toString(): string {
    return `dayLabel: ${this.dayLabel}\ntimeSlots: ${this.timeSlots.map((slot) => slot.toString()).join('\n')}`
  }
}
